import React, {Component} from 'react';
import {connect} from 'react-redux';
import {connectDynamic} from 'go/components/dynamic/dynamicComponent';
import ApiActions from 'go/actions/api';
import {
  API_ORG_GET_ALL_SUBORGS_SUCCESS,
  API_ORG_PROGRAM_GET_SUCCESS,
  SET_APPLICATION_LINKS,
  REMOVE_APPLICATION_LINK,
  UPDATE_APPLICATION_LINK,
} from 'common/types';
import DynamicComponentActions from 'go/actions/dynamicComponent';
import Main from 'app-ui-componentlibrary/dist/go/components/layout/main';
import {
  Grid,
  Container,
  Form,
  Loader,
  Dimmer,
  Pagination,
  Divider,
  Header,
} from 'semantic-ui-react';
import AddSubApplicationContainer from 'go/components/application/addSubApplicationContainer';
import SubApplicationsGrid from 'go/components/application/subApplicationsGrid';
import {TextAreaFieldFrom as TextAreaField} from 'app-ui-componentlibrary';
import {
  FuzzySearch,
  FuzzySort,
} from 'app-ui-componentlibrary/dist/go/components/common/FormControls';
import produce from 'immer';
import {Alert} from 'componentLibrary';

import REST from 'go/requests/rest';

import {
  SEARCH_DATA_RADIO_BTNS,
  SORT_DATA_RADIO_BTNS,
  DEFAULT,
  SUBAPPLICATION_PATHS,
} from './constants';

import {validateSubapplication, getSubOrganizationId} from 'common/utils';
import _ from 'lodash';

const SEARCH_OPTIONS = {
  INITIAL: 'start',
  IN_PROGRESS: 'inprogress',
  SUCCESS: 'success',
  ERROR: 'error',
};

const SORT_OPTIONS = new Map();
SORT_OPTIONS.set('rank', 'payload.rank');
SORT_OPTIONS.set('subApplicantTitle', 'subApplicantTitle');
SORT_OPTIONS.set('applicationType', 'applicationType');
SORT_OPTIONS.set('applicationTitle', 'applicationTitle');
SORT_OPTIONS.set('fedShare', 'payload.fedShareAmount');

const SUBAPPLICATIONS_PAGE_SIZE = 1000;

const COMMENTS_DATAPATH = 'overallComments';

export class SubApplicationsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addingSubApp: false,
      programId: '',
      searchData: [],
      searchOption: '',
      searchValueId: DEFAULT.searchValueId,
      searchValueTitle: DEFAULT.searchValueTitle,
      sortDirection: DEFAULT.sort,
      sortDropdownSelection: '',
      sortBy: '',
      sortPath: '',
      filterValue: '',
      applicationTpeMap: new Map(),
      subOrgs: new Map(),
      comments: _.get(
        this.props.dataPayload,
        COMMENTS_DATAPATH,
        _.get(this.props.dataPayload, 'subapplications.comments')
      ),
      activePage: 1,
      pageSize: this.props.pageSize || SUBAPPLICATIONS_PAGE_SIZE,
    };
  }

  componentDidMount = () => {
    this.getData();
  };

  componentDidUpdate(prevProps) {
    const {organizationId} = this.props;
    const {organizationId: prevOrganizationId} = prevProps;
    if (organizationId !== prevOrganizationId) {
      this.getData();
    }
  }

  getData = () => {
    this.getAllSuborganizations().then(() => {
      this.convertApplicationTypeToMap();
      this.getApplicationLinks();
    });
  };

  convertApplicationTypeToMap = () => {
    let newMap = new Map();
    _.forEach(this.props.applicationTypes.APPLICATION_TYPE, (appType) => {
      newMap.set(appType.id, appType.description);
    });
    this.setState({applicationTpeMap: newMap});
  };

  getPaginatedSubApps = (searchValue) => {
    let field = '';
    let operation = '';
    switch (this.state.searchOption) {
      case 'title':
        field = 'payload.applicationTitle';
        operation = 'match_phrase_prefix';
        break;
      case 'type':
        field = 'payload.applicationType';
        operation = 'match';
        break;
      case 'subapplicant':
        field = 'subOrgId';
        operation = 'match';
        break;
      default:
        field = '';
        operation = '';
        searchValue = null;
    }
    this.setState({loading: true});
    const {activePage} = this.state;
    // const dataOffset = (activePage - 1) * this.state.pageSize;
    const dataOffset = 0;

    try {
      return new Promise((resolve, reject) => {
        if (this.state.sortDropdownSelection === 'rank') {
          REST.search
            .getPaginatedAppLinks_by_child(
              this.props.token,
              this.props.organizationId,
              this.props.programId,
              this.props.entityId,
              this.props.entityType,
              this.state.sortBy,
              this.state.sortDirection,
              operation,
              field,
              dataOffset,
              this.state.pageSize,
              searchValue
            )
            .then((res) => res.json())
            .then((resJson) => resolve(resJson));
        } else {
          REST.search
            .getPaginatedAppLinks_by_parent(
              this.props.token,
              this.props.organizationId,
              this.props.programId,
              this.props.entityId,
              this.props.entityType,
              this.state.sortBy,
              this.state.sortPath,
              this.state.sortDirection,
              operation,
              field,
              dataOffset,
              this.state.pageSize,
              searchValue
            )
            .then((res) => res.json())
            .then((resJson) => resolve(resJson));
        }
      });
    } catch (error) {
      this.setState({
        error: true,
      });
    }
  };

  sortGrantsData = (data, path, sortDirection) => {
    if (path === '' || path === undefined) return data;
    if (sortDirection === 'asc') return _.sortBy(data, path);
    else return _.sortBy(data, path).reverse();
  };

  sortData = (data) => {
    const {sortDropdownSelection, sortDirection} = this.state;
    let sortedData = this.multiSorter(data);
    return this.sortGrantsData(
      sortedData,
      SORT_OPTIONS.get(sortDropdownSelection),
      sortDirection
    );
  };

  getApplicationLinks = async () => {
    const {
      searchOption,
      searchValueTitle,
      searchValueId,
      sortDropdownSelection,
      sortDirection,
    } = this.state;
    let data = {};
    let searchValue = searchOption === 'title' ? searchValueTitle : searchValueId;
    let subApps = await this.getPaginatedSubApps(searchValue);
    if (sortDropdownSelection === 'rank') {
      data = await this.convertByChildPaginationToGenericDisplayCard(subApps.items);
    } else {
      data = await this.convertByParentPaginationToGenericDisplayCard(subApps.items);
    }

    data = this.sortData(data);

    if (sortDropdownSelection !== '') {
      data = this.sortTableColumns(data, sortDropdownSelection, sortDirection);
    }

    this.props.setApplicationLinksInStore({
      links: data,
      total: subApps.total,
    });
    this.setState({loading: false});
  };

  debouncedGetApplicationLinks = _.debounce(() => {
    this.getApplicationLinks();
  }, 500);

  sortTableColumns = (data, sortDropdownSelection, sortDirection) => {
    let field;
    switch (sortDropdownSelection) {
      case 'rank':
      case 'fedShare':
        field = _.orderBy(
          data,
          [(item) => +_.get(item, SUBAPPLICATION_PATHS[sortDropdownSelection])],
          [sortDirection]
        );
        break;
      case 'subApplicantTitle':
      case 'applicationTitle':
      case 'applicationType':
        field = _.orderBy(
          data,
          [
            (item) =>
              _.get(item, SUBAPPLICATION_PATHS[sortDropdownSelection]).toLowerCase(),
          ],
          [sortDirection]
        );
        break;
      default:
        field = '';
    }
    return field;
  };

  sorter = (arr, key) => {
    return key === DEFAULT.primarySort
      ? _.sortBy(arr, (item) => +item.payload.rank)
      : _.sortBy(arr, (item) => item[key] && item[key].toLowerCase());
  };

  multiSorter = (arr) => {
    let payloads = [[], []];

    _.forEach(arr, (item) => {
      _.get(item, SUBAPPLICATION_PATHS.rank) !== undefined
        ? payloads[0].push(item)
        : payloads[1].push(item);
    });

    return _.map(payloads, (item) =>
      item[0] !== undefined && _.get(item[0], SUBAPPLICATION_PATHS.rank) !== undefined
        ? this.sorter(item, DEFAULT.primarySort)
        : this.sorter(item, DEFAULT.secondarySort)
    ).flat();
  };

  saveApplicationLink = (payload, name, value) => {
    const {token} = this.props;
    let resetRank = false;
    return REST.dynamicData
      .getEntityById(this.props.token, payload.entityId)
      .then((res) => res.json())
      .then((resJson) => {
        if (name.indexOf(SUBAPPLICATION_PATHS.subAppCategory) > -1) {
          resetRank = true;
        }
        const updatedData = produce(resJson, (draft) => {
          _.set(draft, name, value);
          if (resetRank) {
            _.set(draft, SUBAPPLICATION_PATHS.rank, null);
          }
        });
        return updatedData;
      })
      .then((newData) => {
        return REST.dynamicData.updateEntity(token, newData).then(() => {
          this.props.updateApplicationLinkInStore({
            entityId: payload.entityId,
            path: name,
            value: value,
          });
          if (resetRank) {
            this.props.updateApplicationLinkInStore({
              entityId: payload.entityId,
              path: SUBAPPLICATION_PATHS.rank,
              value: undefined,
            });
          }
        });
      });
  };

  getSubAppsByTitle = async (value) => {
    this.setState({searchValueTitle: value});
    let data = {};
    let subApps = await this.getPaginatedSubApps(value);
    if (this.state.sortDropdownSelection === 'rank') {
      data = subApps.items.map((item) => ({
        title: item.inner_hits.payload.applicationTitle,
        id: item.entityId,
      }));
    } else {
      data = subApps.items.map((item) => ({
        title: item.payload.applicationTitle,
        id: item.entityId,
      }));
    }
    return data;
  };

  performSearch = async (value) => {
    let searchData = [];
    if (value.length < 1) return [];

    const re = new RegExp(_.escapeRegExp(value), 'i');
    const isMatch = (result) => re.test(result);

    if (this.state.searchOption === 'subapplicant') {
      let newArray = [];
      this.state.subOrgs.forEach((val, key) => {
        if (val != null && isMatch(val)) {
          newArray.push({entityId: key, title: val});
        }
      });
      return newArray;
    } else if (this.state.searchOption === 'type') {
      const mapToObj = (type) => {
        return {code: type.code, title: type.description, entityId: type.id};
      };
      searchData = _.map(this.props.applicationTypes.APPLICATION_TYPE, mapToObj);
      return _.filter(searchData, (o) => isMatch(o.title));
    } else if (this.state.searchOption === 'title') {
      searchData = await this.getSubAppsByTitle(value);
      return searchData;
    }
  };

  handleSearchOption = (event, {value}) => {
    this.setState({
      searchOption: value,
      searchValueId: '',
    });
  };

  handleSave = (entities, name, value) => {
    if (value !== undefined) {
      if (_.isArray(entities)) {
        const promises = _.map(entities, (entity) => {
          let applicationLink = _.find(this.props.applicationLinksData, [
            'entityId',
            entity,
          ]);
          return this.saveApplicationLink(applicationLink, name, value);
        });
        return Promise.all(promises)
          .then(() => {
            if (name.indexOf(SUBAPPLICATION_PATHS.subAppCategory) !== -1) {
              this.setState({
                addedMovedSubApplications: true,
              });
            }
          })
          .catch((err) => {
            console.error('Failed to save applicationLink entities: ', err);
          });
      } else {
        let applicationLink = _.find(this.props.applicationLinksData, [
          'entityId',
          entities,
        ]);
        return this.saveApplicationLink(applicationLink, name, value)
          .then(() => {
            if (name.indexOf(SUBAPPLICATION_PATHS.subAppCategory) !== -1) {
              this.setState({
                addedMovedSubApplications: true,
              });
            }
          })
          .catch((err) => {
            console.error('Failed to save applicationLink entity: ');
          });
      }
    }
  };

  handleCardDelete = (applicationLinkEntities) => {
    this.setState({loading: true});
    const {token, applicationLinksData} = this.props;
    const appLinksEntitiesArray = _.isArray(applicationLinkEntities)
      ? applicationLinkEntities
      : [applicationLinkEntities];

    const category = _.chain(applicationLinksData)
      .find((row) => {
        return _.includes(appLinksEntitiesArray, row.entityId);
      })
      .get(SUBAPPLICATION_PATHS.subAppCategory, '')
      .value();

    const removeSubAppLink = (ids) => {
      return REST.dynamicData
        .deleteMultipleApplicationLinks(token, this.props.entityId, ids)
        .then((response) => response.json())
        .then(() => {
          _.map(ids, (id) => this.props.removeApplicationLinkStore(id));
        })
        .catch((error) => {
          this.setState({
            loading: false,
            error: true,
          });
        });
    };

    removeSubAppLink(appLinksEntitiesArray).then(() => {
      this.reloadApplicationAndValidateRanks(category);
    });
  };

  // Reloading application again after deleting links
  reloadApplicationAndValidateRanks = (category) => {
    REST.dynamicData
      .getEntityById(this.props.token, this.props.entityId)
      .then(REST.handler.handleResponse)
      .then((entity) => {
        this.props.saveEntitySessionData('data', entity);
        this.setState(
          {
            addedMovedSubApplications: true,
            loading: false,
          },
          () => {
            this.validateAllRanks(category);
          }
        );
      });
  };

  getAllRanks = () => {
    const {applicationLinksData} = this.props;
    const allRanks = _.map(applicationLinksData, (link) => {
      return {
        entityId: link.entityId,
        payload: {
          rank: _.get(link, SUBAPPLICATION_PATHS.rank),
        },
      };
    });
    return allRanks;
  };

  handleChange = (entityId, name, value) => {
    this.props.updateApplicationLinkInStore({
      entityId: entityId,
      path: name,
      value: value,
    });
  };

  getRank = (entityId) => {
    return _.chain(this.props)
      .get('applicationLinksData')
      .find((res) => res.entityId === entityId)
      .get(SUBAPPLICATION_PATHS.rank, '')
      .value();
  };

  validateRank = (entityId) => {
    const {applicationLinksData, categoryLabel} = this.props;
    const {errors} = this.state;
    const allRanks = this.getAllRanks();
    const validationProps = {
      applicationLinksData: applicationLinksData,
      categoryLabel: categoryLabel,
      allRanks: allRanks,
      errors: errors,
    };

    this.setState({errors: validateSubapplication(entityId, validationProps)});
  };

  validateAllRanks = (category) => {
    const {applicationLinksData} = this.props;
    _.forEach(applicationLinksData, (row) => {
      if (_.get(row, SUBAPPLICATION_PATHS.subAppCategory) === category) {
        this.validateRank(row.entityId);
      }
    });
  };

  handleValidateAndSaveRank = (entityId) => {
    this.validateRank(entityId);
    const rank = this.getRank(entityId);
    this.handleSave(entityId, SUBAPPLICATION_PATHS.rank, rank);
  };

  handleFilterClear = async () => {
    await this.setState({
      searchOption: '',
      searchValueId: DEFAULT.searchValueId,
      searchValueTitle: DEFAULT.searchValueTitle,
      activePage: 1,
    });
    this.getApplicationLinks();
  };

  handleSortRadioChange = async (event, {value}) => {
    await this.setState({
      sortDirection: value,
      activePage: 1,
    });
    this.getApplicationLinks();
  };

  handleSortDropdownSelection = async (event) => {
    let selectedOption = _.find(
      this.props.sortOptions,
      (o) => o.value === event.target.value
    );
    await this.setState({
      sortDropdownSelection: _.get(selectedOption, 'value'),
      sortBy: _.get(selectedOption, 'sort'),
      sortPath: _.get(selectedOption, 'path'),
      activePage: 1,
    });
    this.getApplicationLinks();
  };

  convertByParentPaginationToGenericDisplayCard = (data) => {
    const {applicationTpeMap, subOrgs} = this.state;
    let subApplicantTitle = '';
    let numProjs = '';
    return Promise.all(
      data.map(async (item) => {
        let costShareDollar = 0;
        const estDuration = _.get(
          item,
          'payload.schedule.estimatedTotalDuration',
          undefined
        );
        subApplicantTitle = await subOrgs.get(parseInt(getSubOrganizationId(item), 10));
        let subAppType = applicationTpeMap.get(
          parseInt(item.payload.applicationType, 10)
        );
        const fedShareContainer = _.get(item, 'payload.budget.share.fedShare');
        costShareDollar = _.reduce(
          fedShareContainer,
          (total, value) => +value + total,
          0
        );
        let subApplicationId =
          item.entityType == 'subApplication'
            ? item.entityId
            : item.inner_hits.payload.subApplicationId;

        const dataObj = {
          applicationTitle: item.payload.applicationTitle,
          applicationType: item.payload.applicationType,
          comments: item.inner_hits.payload.comments,
          numProjSites: numProjs,
          fedShareAmount: costShareDollar,
          estimatedTotalDuration: estDuration,
          primaryAction: _.get(item, 'payload.plan.planDetail.planName', ''),
          subApplicantTitle: subApplicantTitle,
          subApplicationType: subAppType,
          entityId: item.inner_hits.entityId,
          subApplicationId: subApplicationId,
          subGrantId: item.subGrantId,
          payload: {
            rank: item.inner_hits.payload.rank,
            subApplicationCategory: item.inner_hits.payload.subApplicationCategory,
          },
        };
        return dataObj;
      })
    ).then((resp) => {
      return resp;
    });
  };

  convertByChildPaginationToGenericDisplayCard = (data) => {
    const {applicationTpeMap, subOrgs} = this.state;
    let subApplicantTitle = '';
    let numProjs = '';

    return Promise.all(
      data.map(async (item) => {
        let costShareDollar = 0;
        const estDuration = _.get(
          item,
          'inner_hits.payload.schedule.estimatedTotalDuration',
          undefined
        );
        subApplicantTitle = await subOrgs.get(
          parseInt(getSubOrganizationId(item.inner_hits), 10)
        );
        let subAppType = applicationTpeMap.get(
          parseInt(item.inner_hits.payload.applicationType, 10)
        );

        const fedShareContainer = _.get(item, 'inner_hits.payload.budget.share.fedShare');
        costShareDollar = _.reduce(
          fedShareContainer,
          (total, value) => +value + total,
          0
        );

        const dataObj = {
          applicationTitle: item.inner_hits.payload.applicationTitle,
          applicationType: item.inner_hits.payload.applicationType,
          comments: item.payload.comments,
          fedShareAmount: costShareDollar,
          estimatedTotalDuration: estDuration,
          primaryAction: _.get(item, 'inner_hits.plan.planDetail.planName', ''),
          subApplicantTitle: subApplicantTitle,
          subApplicationType: subAppType,
          entityId: item.entityId,
          payload: {
            rank: item.payload.rank,
            subApplicationCategory: item.payload.subApplicationCategory,
          },
        };
        return dataObj;
      })
    ).then((resp) => {
      return resp;
    });
  };

  handlePaginationChange = (e, {activePage}) => {
    this.setState(
      {
        activePage: activePage,
      },
      this.getApplicationLinks
    );
  };

  // Creates a map of subApplicantIDs to subApplicant names
  getAllSuborganizations = () => {
    const {token, organizationId} = this.props;
    return this.props.getAllExistingSubOrg(token, organizationId).then((res) => {
      if (res.type === API_ORG_GET_ALL_SUBORGS_SUCCESS) {
        let newMap = new Map();
        _.forEach(res.payload, (org) => {
          newMap.set(org.organizationId, org.displayName);
        });
        this.setState({subOrgs: newMap});
      }
    });
  };

  handleResultSelect = async (result) => {
    await this.setState({
      searching: SEARCH_OPTIONS.IN_PROGRESS,
      searchValueId: result.entityId,
      searchValueTitle: result.title,
      activePage: 1,
    });
    await this.getApplicationLinks();
  };

  createMiddleSection = (appLink) => {
    return [
      appLink.subApplicantTitle,
      appLink.fedShareAmount,
      appLink.estimatedTotalDuration,
      appLink.subApplicationType,
      appLink.primaryAction,
      appLink.numProjSites,
    ];
  };

  render() {
    const {
      config,
      applicationLinksData,
      organizationId,
      programId,
      entityType,
      validationErrors,
      validationDirtyMap,
      header,
      headerSize,
      isAddingToAmendment,
      activityToWaitFor,
      activityMaxCount,
    } = this.props;

    const {errors, addedMovedSubApplications} = this.state;

    const {categoryOptions, actionOptions, categoryLabel, columns} = config;
    const validationErrorsArray =
      _.isEmpty(validationErrors) || _.isArray(validationErrors)
        ? validationErrors
        : [validationErrors];
    const firstError = _.find(validationErrorsArray, (err) => !err.isValid) || false;
    const errorMessage = firstError ? firstError.message : false;
    const displayError = firstError && validationDirtyMap.dirty;

    let allErrors = {};
    // What errors to show
    if (displayError || addedMovedSubApplications) {
      allErrors = _.chain(validationErrorsArray)
        .map('subAppValidationResults')
        .compact()
        .first()
        .value();
    } else {
      // Just state errors
      allErrors = errors;
    }
    return (
      <Main>
        <Form>
          {header && <Header as={headerSize || 'h1'}>{header}</Header>}
          <Container className="sub-organization" fluid>
            <Grid>
              <Grid.Row>
                <Grid.Column mobile={16} computer={12}>
                  <Grid>
                    <Grid.Row>
                      <Grid.Column align="right">
                        {!this.props.readOnly && !this.props.restrictedPermissions && (
                          <AddSubApplicationContainer
                            isAddingToAmendment={isAddingToAmendment}
                            activityToWaitFor={activityToWaitFor}
                            activityMaxCount={activityMaxCount}
                            categoryLabel={categoryLabel ? categoryLabel : null}
                            options={categoryOptions ? categoryOptions : null}
                            organizationId={organizationId}
                            programId={programId}
                            entityType={entityType}
                            subOrgs={this.state.subOrgs}
                            allowedSubAppTypes={this.props.allowedSubAppTypes}
                            reloadLinks={(success) => {
                              this.setState({
                                addedMovedSubApplications: success,
                              });
                              this.debouncedGetApplicationLinks();
                            }}
                          />
                        )}
                        {displayError && errorMessage && (
                          <Alert
                            size="small"
                            header={'Error'}
                            type="error"
                            dismissable={false}
                          >
                            {errorMessage}
                          </Alert>
                        )}
                      </Grid.Column>
                    </Grid.Row>
                    {!isAddingToAmendment && (
                      <Grid.Row>
                        <Grid.Column>
                          {this.state.loading && (
                            <Dimmer active inverted>
                              <Loader inverted />
                            </Dimmer>
                          )}
                          <SubApplicationsGrid
                            readOnly={this.props.readOnly}
                            results={applicationLinksData}
                            options={actionOptions}
                            categoryLabel={categoryLabel}
                            categoryOptions={categoryOptions}
                            columns={columns}
                            allRanks={this.getAllRanks()}
                            handleCardDelete={this.handleCardDelete}
                            handleChange={this.handleChange}
                            handleSave={this.handleSave}
                            applicationStatus={_.get(this.props, 'applicationStatus')}
                            handleValidateAndSaveRank={this.handleValidateAndSaveRank}
                            errors={allErrors}
                          />
                        </Grid.Column>
                      </Grid.Row>
                    )}
                    <Grid.Row>
                      <Grid.Column>
                        <React.Fragment>
                          {!this.props.readOnly &&
                          !this.props.restrictedPermissions &&
                          !isAddingToAmendment ? (
                            <TextAreaField
                              title="Overall comments (optional)"
                              question="Overall comments (optional)"
                              id="overallComments"
                              name="overallComments"
                              maxLength={4000}
                              rows={4}
                              value={this.state.comments}
                              handleBlur={() => {
                                this.props.saveData(
                                  COMMENTS_DATAPATH,
                                  this.state.comments
                                );
                              }}
                              handleChange={(e, data) =>
                                this.setState({comments: data.value})
                              }
                              displayError={false}
                              errorMessages={['']}
                            />
                          ) : (
                            !this.props.restrictedPermissions &&
                            !isAddingToAmendment && (
                              <p>
                                {'Overall comments (optional)'}
                                <strong>{this.state.comments}</strong>
                              </p>
                            )
                          )}
                        </React.Fragment>
                      </Grid.Column>
                    </Grid.Row>
                  </Grid>
                </Grid.Column>
                {!isAddingToAmendment && !this.props.readOnly && (
                  <Grid.Column mobile={16} computer={4} align="left">
                    <FuzzySearch
                      id="searchLabel"
                      title="Search"
                      name="subAppSearch"
                      radioBtns={SEARCH_DATA_RADIO_BTNS}
                      numColumns={2}
                      radioSelectedValue={this.state.searchOption}
                      inputSearchValue={this.state.searchValueTitle}
                      handleRadioSelection={this.handleSearchOption}
                      performSearch={this.performSearch}
                      handleResultSelect={this.handleResultSelect}
                      clearAllFilters={this.handleFilterClear}
                    />
                    <Divider section />
                    <FuzzySort
                      id="sortByLabel"
                      title="Sort by"
                      name="subAppSort"
                      numColumns={1}
                      radioBtns={SORT_DATA_RADIO_BTNS}
                      radioSelectedValue={this.state.sortDirection}
                      handleRadioSelection={this.handleSortRadioChange}
                      dropdownList={this.props.sortOptions}
                      dropdownSelection={this.state.sortDropdownSelection}
                      handleDropdownSelection={this.handleSortDropdownSelection}
                    />
                  </Grid.Column>
                )}
                <Grid.Column mobile={16} computer={4} align="left" />
              </Grid.Row>
            </Grid>
          </Container>
        </Form>
      </Main>
    );
  }
}

const mapStateToProps = (state) => {
  const {auth, dynamicComponent, applicationLinkData} = state;
  return {
    token: _.get(auth, 'token'),
    dataPayload: _.get(dynamicComponent, 'data.payload'),
    applicationTypes: _.get(dynamicComponent, 'context.loadRefApplicantType'),
    applicationLinksData: _.get(dynamicComponent, 'applicationLinksData.data'),
    applicationLinksDataTotal: _.get(applicationLinkData, 'total'),
  };
};

export const mapDispatchToProps = (dispatch) => ({
  getAllExistingSubOrg: (token, orgId) => {
    const action = ApiActions.organization.getAllSuborganizations(token, orgId);
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_GET_ALL_SUBORGS_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  getOrgPrograms: (token, orgId, parentOrgId) => {
    const action = ApiActions.organizationRelationship.getAllOrganizationProgramsByParentOrgId(
      token,
      orgId,
      parentOrgId
    );
    const response = dispatch(action);
    return response.then((res) => {
      res.hasResults =
        res.type === API_ORG_PROGRAM_GET_SUCCESS && !_.isEmpty(res.payload);
      return res;
    });
  },
  setApplicationLinksInStore: (payload) => {
    dispatch({
      type: SET_APPLICATION_LINKS,
      data: payload,
    });
    dispatch(DynamicComponentActions.validateConfigRules());
  },
  removeApplicationLinkStore: (entityId) => {
    dispatch({
      type: REMOVE_APPLICATION_LINK,
      entityId: entityId,
    });
    dispatch(DynamicComponentActions.validateConfigRules());
  },
  updateApplicationLinkInStore: (payload) => {
    dispatch({
      type: UPDATE_APPLICATION_LINK,
      data: payload,
    });
    dispatch(DynamicComponentActions.validateConfigRules());
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(connectDynamic(SubApplicationsContainer));
